const URLS = {
    miaPlayer: 'https://link.rubiconproject.com/magnite/23292.js',
};

export default URLS;
